import { Source, SourceType } from '../src/constants/Source';

interface GetScreenFromUrlArgs {
  orgName?: string;
  url?: URL;
}

export const getScreenFromUrl = ({
  orgName = '',
  url = new URL(window.location.href),
}: GetScreenFromUrlArgs = {}): SourceType => {
  const paths = url.pathname.split('/');
  const firstPathSegment = paths[1];
  let screen: SourceType;

  if (orgName && paths.length === 2 && firstPathSegment === orgName) {
    screen = Source.orgProfileEditScreen;
  } else if (firstPathSegment === 'b') {
    screen = Source.boardScreen;
  } else if (firstPathSegment === 'c') {
    screen = Source.cardDetailScreen;
  } else if (firstPathSegment === 'power-ups') {
    screen = Source.publicDirectoryScreen;
  } else if (/^search/.test(firstPathSegment)) {
    screen = Source.searchResultsScreen;
  } else if (url.pathname.includes('billing')) {
    screen = Source.teamBillingScreen;
  } else if (url.pathname.includes('home')) {
    screen = Source.teamScreen;
  } else if (firstPathSegment === 'shortcuts') {
    screen = Source.shortcutsScreen;
  } else if (url.pathname === '/') {
    screen = Source.memberHomeScreen;
  } else {
    screen = Source.unknownScreen;
  }

  return screen;
};
